import MuiTabs, { TabsProps } from '@mui/material/Tabs';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

import styles from './styles';

const useStyles = makeStyles(styles);

const Tabs: React.FC<TabsProps> = (props) => {
  const classes = useStyles();

  return (
    <MuiTabs className={classes.tabs} {...props} data-testid="of-tabs">
      {props.children}
    </MuiTabs>
  );
};

export default Tabs;
